<template>
  <v-container fluid>
    <v-row>
      <v-col></v-col>
    </v-row>
    <v-row>
      <v-col></v-col>
    </v-row>
    <v-card flat>
      <v-card-title v-if="standAloneMode">
        <v-toolbar>
          <v-icon color="brown">text_rotation_none</v-icon>
          <v-toolbar-title class="font-weight-light">
            <v-row>
              <v-col>
                <div>
                  &nbsp;Datos Adicionales del Crédito Nº {{ model.numero }}
                </div>
              </v-col>
            </v-row>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.stop="hideActiveSubTask"
            ><v-icon>close</v-icon></v-btn
          >
        </v-toolbar>
      </v-card-title>

      <v-card-text>
        <v-card v-if="model.mostrarCalculoRenovacion">
          <v-card-subtitle>
            Renovación Anticipada
            <v-btn
              x-small
              color="indigo"
              outlined
              dark
              @click="calcularRenovacion"
              >Calcular</v-btn
            >
          </v-card-subtitle>
          <v-card-text v-if="showInfoRenvacion">
            <v-row dense>
              <v-col>
                Saldo a Renovar: {{ infoRenovacion.totalARenovar | currency }}
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-row>
          <v-col></v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <v-autocomplete
              v-model="model.formaLlegadaId"
              :items="listFormasLlegada"
              :disabled="!canCreate && !canUpdate"
              item-text="descripcion"
              item-value="id"
              label="Cómo llegó el solicitante"
              :menu-props="{ minWidth: '200' }"
            ></v-autocomplete>
          </v-col>
          <v-col>
            <v-autocomplete
              v-model="model.motivoSolicitudId"
              :items="listDestinosCredito"
              :disabled="!canCreate && !canUpdate"
              item-text="descripcion"
              item-value="id"
              label="Destino del crédito"
              :menu-props="{ minWidth: '200' }"
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="6">
            <v-autocomplete
              v-model="model.medioPagoId"
              :items="listMediosPago"
              :disabled="!canCreate && !canUpdate"
              item-text="descripcion"
              item-value="id"
              label="Desembolso del crédito mediante"
              :menu-props="{ minWidth: '200' }"
            ></v-autocomplete>
          </v-col>
          <v-col> </v-col>
        </v-row>

        <!-- transferencias -->
        <v-row v-if="model.medioPagoId == 2" dense>
          <v-row dense>
            <v-col>
              <v-text-field
                label="Banco/Formato"
                v-model="model.bancoDesembolso"
                :disabled="!canCreate && !canUpdate"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                label="Nº Identificación"
                v-model="model.numeroDesembolso"
                :disabled="!canCreate && !canUpdate"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <v-text-field
                label="Comentarios Desembolso"
                v-model="model.comentariosDesembolso"
                :disabled="!canCreate && !canUpdate"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-row>
        <!-- /transferencias -->

        <!-- giros -->
        <v-row v-if="model.medioPagoId == 3" dense>
          <v-row dense>
            <v-col>
              <v-text-field
                label="Sucursal Receptora"
                v-model="model.sucursalReceptoraGiro"
                :disabled="!canCreate && !canUpdate"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                label="Sucursal Pagadora"
                v-model="model.sucursalPagadoraGiro"
                :disabled="!canCreate && !canUpdate"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <v-text-field
                label="Comentarios Desembolso"
                v-model="model.comentariosDesembolso"
                :disabled="!canCreate && !canUpdate"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-row>
        <!-- /giros -->

        <!-- cheque -->
        <v-row v-if="model.medioPagoId == 4" dense>
          <v-row dense>
            <v-col>
              <v-text-field
                label="Banco"
                v-model="model.bancoDesembolso"
                :disabled="!canCreate && !canUpdate"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                label="Nº Cheque"
                v-model="model.numeroDesembolso"
                :disabled="!canCreate && !canUpdate"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                label="Fecha Cheque"
                v-model="model.fechaChequeDesembolso"
                :disabled="!canCreate && !canUpdate"
                type="date"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <v-text-field
                label="Comentarios Desembolso"
                v-model="model.comentariosDesembolso"
                :disabled="!canCreate && !canUpdate"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-row>
        <!-- /cheque -->

        <!-- dirigido -->
        <v-row v-if="model.medioPagoId == 5" dense>
          <v-row dense>
            <v-col>
              <v-autocomplete
                v-model="model.pagoAGrupoComercialId"
                :items="listGruposComerciales"
                item-text="nombre"
                item-value="id"
                label="Al Comerciante"
                :menu-props="{ minWidth: '200' }"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-row>
        <!-- /dirigido -->

        <!-- tarjeta -->
        <v-row v-if="model.medioPagoId == 6" dense>
          <v-row dense>
            <v-col>
              <v-text-field
                label="Marca"
                v-model="model.marcaTarjetaDesembolso"
                :disabled="!canCreate && !canUpdate"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                label="Nº Cupón"
                v-model="model.numeroDesembolso"
                :disabled="!canCreate && !canUpdate"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <v-text-field
                label="Comentarios Desembolso"
                v-model="model.comentariosDesembolso"
                :disabled="!canCreate && !canUpdate"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-row>
        <!-- /tarjeta -->

        <v-row dense>
          <v-col
            cols="6"
            v-if="
              $store.state.parametrosGenerales.datosAdicionalesMostraVendedor
            "
          >
            <v-autocomplete
              v-model="model.vendedorId"
              :items="listVendedores"
              :disabled="!canCreate && !canUpdate"
              item-text="descripcion"
              item-value="id"
              label="Vendedor"
              :menu-props="{ minWidth: '200' }"
            ></v-autocomplete>
          </v-col>
          <v-col cols="6">
            <v-text-field
              label="Voluntad de Pago"
              v-model="model.voluntadDePago"
              :disabled="!canCreate && !canUpdate"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row align="center">
          <v-col cols="12">
            <v-banner color="blue" dark>
              <v-row align="center" dense>
                <v-col>
                  Empleador: {{ model.empleadorNombre }} / CUIT :
                  {{ model.empleadorCuit }}
                </v-col>
              </v-row>

              <!-- Edición empleador -->
              <v-row align="center" dense v-if="canEditEmpleador">
                <v-col cols="12" sm="5">
                  <ValidationProvider
                    name="cuit del empleador"
                    rules="required|digits:11"
                    v-slot="{ errors, valid }"
                  >
                    <v-text-field
                      label="Cuit"
                      v-model="empleoEditor.cui"
                      mask="##-########-#"
                      clearable
                      v-validate="'required'"
                      required
                      data-vv-name="cuit del empleador"
                      append-outer-icon="search"
                      @click:append-outer="buscarEmpleadorPorCui()"
                      @keydown.enter.prevent="buscarEmpleadorPorCui()"
                      :error-messages="errors"
                      :success="valid"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" sm="7">
                  <ValidationProvider 
                  name="empleador" 
                  rules="required|max:100" 
                  v-slot="{ errors, valid }"
                  >
                    <v-text-field
                      label="Empleador"
                      v-model="empleoEditor.empleador"
                      required
                      data-vv-name="empleador"
                      :error-messages="errors"
                      :success="valid"
                      disabled
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>

              <v-row align="center" dense>
                <v-col>
                  <v-select
                    :items="listSituacionesLaboralesActividades"
                    v-model="model.situacionLaboralActividadId"
                    item-text="descripcion"
                    item-value="id"
                    label="Situación Laboral"
                    :disabled="!canEditEmpleador"
                  ></v-select>
                </v-col>
              </v-row>
            </v-banner>
          </v-col>
        </v-row>

        <v-row align="center" dense>
          <!-- <v-col>
                <v-switch v-model="model.carpetaFideicomisoRealizada" label="Carpeta Fideicomiso Realizada" :disabled="!canCreate && !canUpdate"> </v-switch>
              </v-col> -->
          <v-col>
            <v-switch
              v-model="model.cuotaEnViaje"
              label="Cuota en Viaje"
              :disabled="!canCreate && !canUpdate"
            >
            </v-switch>
          </v-col>
          <!-- Marca Canal Digital: solo visible/operable para usuarios con el rol Canal Digital.
               Se guarda inmediatamente por endpoint propio, no con el botón Guardar del form -->
          <v-col v-if="esCanalDigital">
            <v-switch
              v-model="model.canalDigital"
              label="Canal Digital"
              @change="marcarCanalDigital"
            >
            </v-switch>
          </v-col>
        </v-row>

        <v-row align="center" dense>
          <v-col cols="6">
            <v-text-field
              label="$ Renova"
              v-model="model.importeRenovacion"
              :disabled="true"
            ></v-text-field>
          </v-col>
          <!-- <v-col cols="6">
                <v-text-field label="$ Retención" v-model="model.importeRetencion" :disabled="!canCreate && !canUpdate"></v-text-field>
              </v-col> -->
        </v-row>

        <!-- anses -->
        <v-row align="center" dense>
          <v-col
            v-if="
              $store.state.parametrosGenerales
                .datosAdicionalesMostraNumeroBeneficioAnses
            "
          >
            <v-text-field
              label="Nº Beneficio ANSES"
              v-model="model.numeroBeneficioAnses"
              :disabled="!canCreate && !canUpdate"
            ></v-text-field>
          </v-col>
          <v-col
            v-if="
              $store.state.parametrosGenerales.datosAdicionalesMostraNumeroAnses
            "
          >
            <v-text-field
              label="Nº ANSES"
              v-model="model.numeroAnses"
              :disabled="!canCreate && !canUpdate"
            ></v-text-field>
          </v-col>
        </v-row>

        <!-- rapipago -->
        <v-row
          align="center"
          v-if="
            $store.state.parametrosGenerales
              .datosAdicionalesMostraNumeroRapipago
          "
          dense
        >
          <v-col>
            <v-text-field
              label="Nº Rapipago"
              v-model="model.numeroRapipago"
              :disabled="!canCreate && !canUpdate"
            ></v-text-field>
          </v-col>
          <v-col> </v-col>
        </v-row>

        <!-- datos archivo -->
        <!-- <v-row  align="center" v-if="$store.state.parametrosGenerales.datosAdicionalesMostraDatosArchivo" dense>
              <v-col>
                <v-text-field label="Nº Caja Legajo" v-model="model.numeroCajaLegajo" :disabled="!canCreate && !canUpdate"></v-text-field>
              </v-col>
              <v-col>
                <v-text-field label="Nº Caja Pagaré" v-model="model.numeroCajaPagare" :disabled="!canCreate && !canUpdate"></v-text-field>
              </v-col>
            </v-row> -->

        <!-- consulta a instituto -->
        <v-row
          align="center"
          v-if="
            $store.state.parametrosGenerales
              .datosAdicionalesMostraDatosConsultaInstituto
          "
          dense
        >
          <v-col>
            <v-text-field
              label="Fecha Consulta"
              v-model="model.fechaConsultaInstituto"
              type="date"
              prepend-icon="event"
              :disabled="!canCreate && !canUpdate"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              label="Nº Consulta"
              v-model="model.numeroConsultaInstituto"
              :disabled="!canCreate && !canUpdate"
            ></v-text-field>
          </v-col>
        </v-row>

        <!-- conjunto datos 1 -->
        <v-row
          align="center"
          v-if="
            $store.state.parametrosGenerales
              .datosAdicionalesMostraConjuntoDatos1
          "
          dense
        >
          <v-col>
            <v-text-field
              label="# Refs. Comerciales"
              v-model="model.cantidadReferenciasComerciales"
              :disabled="!canCreate && !canUpdate"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              label="Situación BCRA"
              v-model="model.situacionBCRA"
              :disabled="!canCreate && !canUpdate"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              label="Monto Endeudamiento"
              v-model="model.montoEndeudamiento"
              :disabled="!canCreate && !canUpdate"
            ></v-text-field>
          </v-col>
        </v-row>

        <!-- situacion judicial -->
        <v-row
          align="center"
          v-if="
            $store.state.parametrosGenerales.datosAdicionalesMostraDatosJuicio
          "
          dense
        >
          <v-col>
            <v-switch
              v-model="model.enJuicio"
              label="En Juicio"
              :disabled="!canCreate && !canUpdate"
            >
            </v-switch>
          </v-col>
          <v-col>
            <v-text-field
              v-if="model.enJuicio"
              label="Fecha Inicio Juicio"
              v-model="model.fechaInicioJuicio"
              type="date"
              prepend-icon="event"
              :disabled="!canCreate && !canUpdate"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="4">
            <v-text-field
              label="Intentos Gueno"
              v-model="model.intentosGueno"
              type="number"
              :disabled="
                (!canCreate && !canUpdate) || !canUpdateInteraccionesGueno
              "
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row align="center" dense>
          <v-col cols="12">
            <v-text-field
              v-model="model.desgravacionImpositiva"
              label="Desgravación Impositiva"
              :disabled="!canCreate && !canUpdate"
            ></v-text-field>
          </v-col>
        </v-row>

        <!-- denuncia activa -->
        <!-- <v-row  align="center"  dense>
              <v-col>
                <v-switch v-model="model.denunciaActiva" label="Denuncia Activa" :disabled="!canCreate && !canUpdate"> </v-switch>
              </v-col>
            </v-row> -->

        <!-- observaciones -->
        <v-row align="center" dense>
          <v-col cols="12">
            <v-text-field
              v-model="model.observaciones"
              label="Observaciones/Comentarios"
              :disabled="!canCreate && !canUpdate"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row align="center" dense>
          <v-col cols="3">
            <v-text-field
              v-model="model.nosisScore"
              label="Nosis Score"
              :disabled="true"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row align="center" dense>
          <v-col cols="3">
            Tipo Legajo:
            {{ tipoLegajoDescripcion }}
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider v-if="standAloneMode"></v-divider>
      <v-card-actions v-if="standAloneMode">
        <v-btn color="blue darken-1" text @click.stop="hideActiveSubTask"
          >Cerrar</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          color="green "
          dark
          @click.stop="save"
          :disabled="!canCreate && !canUpdate"
          >Guardar Cambios</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import Vue from 'vue';
import { http } from '@/axios';
import { mapGetters, mapMutations } from 'vuex';

export default {
  components: {
    ValidationProvider,
  },
  data: () => ({
    editModeOn: false,
    loading: false,
    listFormasLlegada: [],
    listMediosPago: [],
    listDestinosCredito: [],
    listVendedores: [],
    listGruposComerciales: [],
    listSituacionesLaboralesActividades: [],
    model: {},
    showInfoRenvacion: false,
    infoRenovacion: {},
    empleoEditor: {
      cui: '',
      empleador: '',
      empleadorId: 0,
    },
  }),
  props: {
    standAloneMode: {
      type: Boolean,
      default: true,
    },
    personaId: {
      type: String,
      required: false,
      default: null,
    },
    creditoId: {
      type: String,
      required: false,
    },
    cuentaSeleccionada: {
      type: Object,
      required: false,
      default: function () {
        return {};
      },
    },
  },
  watch: {
    model: {
      handler() {},
      deep: true,
    },
    'model.medioPagoId': {
      async handler() {
        if (this.model.medioPagoId == 5) {
          await this.loadGruposComerciales();
        }
      },
    },
  },
  computed: {
    ...mapGetters([
      'user',
      'checkCanCreate',
      'checkCanUpdate',
      'checkCanDelete',
      'checkCanAccess',
    ]),
    esCanalDigital: function () {
      return (
        this.user.roles &&
        this.user.roles.some(
          (r) => r.trim().toLowerCase() === 'canal digital'
        )
      );
    },
    canCreate: function () {
      return (
        this.checkCanCreate('ap-datos-adicionales-credito') &&
        this.creditoId == '00000000-0000-0000-0000-000000000000'
      );
    },
    canUpdate: function () {
      return (
        this.checkCanUpdate('ap-datos-adicionales-credito') &&
        this.creditoId != '00000000-0000-0000-0000-000000000000'
      );
    },
    canUpdateInteraccionesGueno: function () {
      return (
        this.checkCanAccess('ap-actualizar-interacciones-gueno') &&
        this.creditoId != '00000000-0000-0000-0000-000000000000'
      );
    },
    tipoLegajoDescripcion: function () {
      if (this.model.tipoLegajoId == 1) return 'Smarter';
      if (this.model.tipoLegajoId == 2) return 'Gueno';
      if (this.model.tipoLegajoId == 3) return 'Digiventures';
      if (this.model.tipoLegajoId == 4) return 'DigitalMinds';
      if (this.model.tipoLegajoId == 5) return 'CardCred';
      if (this.model.tipoLegajoId == 6) return 'Digital Argen';

      return 'No especifica';
    },
    canEditEmpleador: function () {
      return (
        this.checkCanUpdate('ap-puede-modificar-empleadores') &&
        this.creditoId != '00000000-0000-0000-0000-000000000000'
      );
    },
  },
  created() {
    this.loadFormasLlegada();
    this.loadDestinosCredito();
    this.loadMediosPago();
    this.loadSituacionesLaboralesActividades();
    if (this.creditoId) {
      this.loadDatosCredito();
    }
  },
  methods: {
    ...mapMutations([
      'hideActiveSubTask',
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
    ]),
    async nuevaCuentaClosed() {
      this.setData();
    },
    async loadDatosCredito() {
      this.loading = true;
      try {
        var result = await http.get(
          'creditos/datosadicionales?creditoId=' + this.creditoId
        );
        this.model = result;
        //this.model.fechaChequeDesembolso = this.$moment(this.model.fechaChequeDesembolso).format('YYYY-MM-DD')

        console.log(this.model);
      } catch (error) {
        // Error
        Vue.$log.error(error);
      }
      this.loading = false;
    },
    async loadFormasLlegada() {
      this.loading = true;
      try {
        var result = await http.get('tiposformallegada'); // traigo todas
        this.listFormasLlegada = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadMediosPago() {
      this.loading = true;
      try {
        var result = await http.get('tiposmediopagocredito'); // traigo todas
        this.listMediosPago = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadSituacionesLaboralesActividades() {
      this.loading = true;
      try {
        var result = await http.get('situacioneslaborales/actividades');
        this.listSituacionesLaboralesActividades = result.list;
      } catch (error) {
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadDestinosCredito() {
      this.loading = true;
      try {
        var result = await http.get('tiposdestinocredito'); // traigo todas
        this.listDestinosCredito = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadGruposComerciales() {
      this.loading = true;
      try {
        var result = await http.get('gruposcomerciales?limit=999'); // traigo todas
        this.listGruposComerciales = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async marcarCanalDigital() {
      this.loading = true;
      try {
        var params = {};
        params.creditoId = this.creditoId;
        params.marcar = this.model.canalDigital;

        await http.post(
          'creditos/marcarcanaldigital',
          JSON.stringify({ parametros: params })
        );

        // la marca se guarda sola al tildar (no hace falta apretar Guardar)
        this.alertSuccess(
          this.model.canalDigital
            ? 'Crédito marcado como Canal Digital'
            : 'Crédito desmarcado de Canal Digital'
        );
      } catch (error) {
        // si falla, vuelvo el switch al estado anterior
        this.model.canalDigital = !this.model.canalDigital;
        this.alertError(error);
      }
      this.loading = false;
    },
    async save() {
      this.loading = true;

      console.log(this.model.situacionLaboralActividadId);

      try {
        await http.post(
          'creditos/updatedatosadicionales',
          JSON.stringify({ parametros: this.model })
        );

        this.alertSuccess('Los cambios han sido registrados');
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async calcularRenovacion() {
      this.loading = true;
      try {
        this.infoRenovacion = await http.get(
          'creditos/getinfocalculorenovacion?creditoId=' + this.creditoId
        );
        console.log(this.infoRenovacion);
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;

      this.showInfoRenvacion = true;
    },
    async buscarEmpleadorPorCui() {
      if (this.loading) return;

      const cui = this.empleoEditor.cui;
      if (!cui || cui.length < 11) {
        this.alertWarning('El CUIT debe tener 11 dígitos');
        return;
      }

      this.loading = true;
      try {
        const result = await http.get(
          'empleadores/listarporcui?cui=' + cui
          + '&limit=1&page=1'
          );

        const item = (result && result.list && result.list.length)
          ? result.list[0]
          : null;

        if (!item || !item.id) {
          this.setEmpleadorNotFound();
          return;
        }
        this.setEmpleadorBusqueda(item);
      } catch (e) {
        this.alertError('Error consultando empleador');
      } finally {
        this.loading = false;
      }
    },

    setEmpleadorBusqueda(empleador) {
      const cui = empleador.cui || this.empleoEditor.cui;

      this.empleoEditor.empleadorId = empleador.id;
      this.empleoEditor.empleador = empleador.nombre || '';
      this.empleoEditor.cui = cui;

      // reflejar en tu model para que quede guardado en esta pantalla
      this.model.empleadorId = empleador.id;
      this.model.empleadorNombre = this.empleoEditor.empleador;
      this.model.empleadorCuit = cui;
    },

    setEmpleadorNotFound() {
      this.empleoEditor.empleador   = '';
      this.empleoEditor.empleadorId = null;
      this.alertError('No se encontró empleador con ese CUIT');
    },
  },
};
</script>
